<nav class="ops-top {{theme}} no-print">
  <div class="texture" [ngClass]="navigationMenuCssClass"></div>

  <ul class="top-items" aria-expanded="false">
    <li *ngIf="appSettingLoaded">
      <div class="dropdown show">
        <a href="#" class="font-size-button" role="button" id="FontSizeDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="icon icon-font-size"></i> <span style="font-size:11px;">Font Size</span>
        </a>
        <div class="dropdown-menu font-size-dropdown" aria-labelledby="FontSizeDropdown" (click)="$event.stopPropagation()">
          <div class="dropdown-header">Change Font Size</div>
          <div role="separator" style="padding: 0px; background-color: #e5e5e5 !important;" class="divider"></div>
          <div class="dropdown-item">
            <div class="font-preview-container">
              <span [ngStyle]="{'font-size': fontSize + 'px'}">Font Size {{fontSize}}px</span>
            </div>
            <div class="slider-container">
              <div class="font-min">A</div>
              <div class="range-slider">
                <input class="input-range" type="range" min="10" max="18" step="2" [(ngModel)]="fontSize">
              </div>
              <div class="font-max">A</div>
            </div>
          </div>
          <div><button class="button-font-size" (click)="applyFontSize($event)">Apply</button></div>
        </div>
      </div>

    </li>
    <li>
      <a [ngClass]="tooltipCssClass" (click)="fullScreenClick()"><i class="icon icon-resize-full"></i>Full screen</a>
    </li>
    <li> <a target="_blank" href="{{supportLink}}">Support</a> </li>
    <li> <a (click)="logout()">Log out <i class="fa fa-power-off"></i></a> </li>
  </ul>

</nav>
